import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-content-container overflow-hidden" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-8" }
const _hoisted_4 = { class: "col-lg-4" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-xxl-8" }
const _hoisted_7 = { class: "col-xxl-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Stats = _resolveComponent("Stats")!
  const _component_SalesAnalytics = _resolveComponent("SalesAnalytics")!
  const _component_CustomerSegmentation = _resolveComponent("CustomerSegmentation")!
  const _component_CategoriesTab = _resolveComponent("CategoriesTab")!
  const _component_OrderDetails = _resolveComponent("OrderDetails")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Stats),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_SalesAnalytics)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_CustomerSegmentation)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_CategoriesTab)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_OrderDetails)
      ])
    ])
  ]))
}